/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _indexConfig = __webpack_require__(1);

	var _indexRoute = __webpack_require__(2);

	var _indexRun = __webpack_require__(4);

	// services (components)

	var _componentsApiService = __webpack_require__(5);

	var _componentsUtilService = __webpack_require__(6);

	var _componentsHttpInterceptorService = __webpack_require__(7);

	// services

	var _detailServicesDetailService = __webpack_require__(8);

	// controllers

	var _featuredFeaturedController = __webpack_require__(9);

	var _trendingTrendingController = __webpack_require__(10);

	var _newNewController = __webpack_require__(11);

	var _detailDetailController = __webpack_require__(12);

	// directives (components)

	var _componentsHeadLogoHeadLogoDirective = __webpack_require__(13);

	var _componentsNavbarNavbarDirective = __webpack_require__(14);

	var _componentsPopoverMenuPopoverMenuDirective = __webpack_require__(15);

	var _componentsProgressIndicatorProgressIndicatorDirective = __webpack_require__(16);

	var _componentsStageListStageListDirective = __webpack_require__(17);

	var _componentsStageBadgeStageBadgeDirective = __webpack_require__(18);

	// directives

	var _detailDirectivesDetailDescriptionDirective = __webpack_require__(19);

	var _detailDirectivesDetailButtonsDirective = __webpack_require__(20);

	angular.module('braindotsWeb', ['ngTouch', 'ngSanitize', 'ui.router'])
	// .constant('moment', moment)
	.config(_indexConfig.config).config(_indexRoute.routerConfig).run(_indexRun.runBlock)

	// services (components)
	.service('ApiService', _componentsApiService.ApiService).service('UtilService', _componentsUtilService.UtilService).service('HttpInterceptorService', _componentsHttpInterceptorService.HttpInterceptorService)

	// services
	.service('DetailService', _detailServicesDetailService.DetailService)

	// controllers
	.controller('FeaturedController', _featuredFeaturedController.FeaturedController).controller('TrendingController', _trendingTrendingController.TrendingController).controller('NewController', _newNewController.NewController).controller('DetailController', _detailDetailController.DetailController)

	// directives (components)
	.directive('headLogo', _componentsHeadLogoHeadLogoDirective.HeadLogoDirective).directive('navbar', _componentsNavbarNavbarDirective.NavbarDirective).directive('popoverMenu', _componentsPopoverMenuPopoverMenuDirective.PopoverMenuDirective).directive('progressIndicator', _componentsProgressIndicatorProgressIndicatorDirective.ProgressIndicatorDirective).directive('stageList', _componentsStageListStageListDirective.StageListDirective).directive('stageBadge', _componentsStageBadgeStageBadgeDirective.StageBadgeDirective)

	// directives
	.directive('detailDescription', _detailDirectivesDetailDescriptionDirective.DetailDescriptionDirective).directive('detailButtons', _detailDirectivesDetailButtonsDirective.DetailButtonsDirective);

/***/ },
/* 1 */
/***/ function(module, exports) {

	'use strict';

	config.$inject = ["$logProvider", "$locationProvider", "$httpProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.config = config;

	function config($logProvider, $locationProvider, $httpProvider) {
	  'ngInject';

	  // Enable/Disable log
	  $logProvider.debugEnabled(false);

	  // $locationProvider.html5Mode(true);
	  $httpProvider.interceptors.push('HttpInterceptorService');
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	routerConfig.$inject = ["$stateProvider", "$urlRouterProvider"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.routerConfig = routerConfig;

	var _configEnvironment = __webpack_require__(3);

	function routerConfig($stateProvider, $urlRouterProvider) {
	  'ngInject';
	  $stateProvider.state('featured', {
	    url: '/featured',
	    views: {
	      'nav': { template: '<navbar></navbar>' },
	      'main': {
	        templateUrl: 'app/featured/featured.html',
	        controller: 'FeaturedController',
	        controllerAs: 'vm'
	      }
	    }
	  }).state('trending/today', {
	    url: '/trending/today',
	    views: {
	      'nav': { template: '<navbar></navbar>' },
	      'main': {
	        templateUrl: 'app/trending/trending.html',
	        controller: 'TrendingController',
	        controllerAs: 'vm'
	      }
	    }
	  }).state('trending/three_days', {
	    url: '/trending/three_days',
	    views: {
	      'nav': { template: '<navbar></navbar>' },
	      'main': {
	        templateUrl: 'app/trending/trending.html',
	        controller: 'TrendingController',
	        controllerAs: 'vm'
	      }
	    }
	  }).state('trending/week', {
	    url: '/trending/week',
	    views: {
	      'nav': { template: '<navbar></navbar>' },
	      'main': {
	        templateUrl: 'app/trending/trending.html',
	        controller: 'TrendingController',
	        controllerAs: 'vm'
	      }
	    }
	  }).state('trending/month', {
	    url: '/trending/month',
	    views: {
	      'nav': { template: '<navbar></navbar>' },
	      'main': {
	        templateUrl: 'app/trending/trending.html',
	        controller: 'TrendingController',
	        controllerAs: 'vm'
	      }
	    }
	  }).state('new', {
	    url: '/new',
	    views: {
	      'nav': { template: '<navbar></navbar>' },
	      'main': {
	        templateUrl: 'app/new/new.html',
	        controller: 'NewController',
	        controllerAs: 'vm'
	      }
	    }
	  }).state('detail', {
	    url: '/?:id',
	    views: {
	      'main': {
	        templateUrl: 'app/detail/detail.html',
	        controller: 'DetailController',
	        controllerAs: 'vm'
	      }
	    }
	  });

	  $urlRouterProvider.otherwise(function ($injector) {
	    var $state = $injector.get('$state');
	    var $window = $injector.get('$window');
	    var query = $window.location.search;
	    if (query.indexOf('?id=') === 0) {
	      // e.g.
	      //   http://dev.braindotsapp.com/stage/#/?id=968
	      var newHref = _configEnvironment.environment.detailStateUrl + (query.split('=')[1] || '');
	      $window.location.replace(newHref);
	    } else {
	      $state.go('featured');
	    }
	  });
	}

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	var environment = {
	  detailStateUrl: 'http://web.braindotsapp.com/stage/#/?id=',
	  apiHost: 'http://api.braindotsapp.com/',
	  storageUrl: 'http://storage.braindotsapp.com/',
	  urlScheme: 'jp.co.translimit.braindots://stage/play?stage_id=',
	  universalLinks: 'http://www.braindotsapp.com/stage/?id='
	};
	exports.environment = environment;

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';

	runBlock.$inject = ["$log"];
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.runBlock = runBlock;

	function runBlock($log) {
	  'ngInject';
	  $log.debug('runBlock end');
	}

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _configEnvironment = __webpack_require__(3);

	var ApiService = (function () {
	  ApiService.$inject = ["$log", "$http"];
	  function ApiService($log, $http) {
	    'ngInject';

	    _classCallCheck(this, ApiService);

	    this.$log = $log;
	    this.$http = $http;
	    this.apiHost = _configEnvironment.environment.apiHost;
	  }

	  /**
	   * ピックアップステージを取得
	   * @return {Promise}
	   */

	  _createClass(ApiService, [{
	    key: 'getFeaturedStages',
	    value: function getFeaturedStages() {
	      var _this = this;

	      return this.$http.get(this.apiHost + '/v1/public/craft/stage/pickups', { cache: true }).then(function (response) {
	        return response.data;
	      })['catch'](function (error) {
	        _this.$log.error(angular.toJson(error.data, true));
	      });
	    }

	    /**
	     * トレンドステージを取得
	     * @param {number} term
	     *   1ヶ月以内 -> 1, 1週間以内 -> 2 3日以内 -> 3, 今日 -> 4
	     * @return {Promise}
	     */
	  }, {
	    key: 'getTrendingStages',
	    value: function getTrendingStages(term) {
	      term = term || 1;
	      return this._getStages(1, term, true);
	    }

	    /**
	     * 新着ステージを取得
	     * @return {Promise}
	     */
	  }, {
	    key: 'getNewStages',
	    value: function getNewStages() {
	      return this._getStages(0, 0, true);
	    }

	    /**
	     * ステージ詳細を取得
	     * @param {string} id | stage id
	     */
	  }, {
	    key: 'getStageDetail',
	    value: function getStageDetail(id) {
	      var _this2 = this;

	      return this.$http.get(this.apiHost + '/v1/public/craft/stage/detail?stage_id=' + id).then(function (response) {
	        return response.data;
	      })['catch'](function (error) {
	        _this2.$log.error(angular.toJson(error.data, true));
	      });
	    }

	    /**
	     * ステージを取得
	     * @param {number} sortType
	     * sort
	     *   0 LATEST # 最新順
	     *   1 LIKE_COUNT # いいね多い順
	     *   2 FAVORITE_COUNT # お気に入り多い順
	     *   3 STAGE_ID # ステージIDの昇順
	     * term_type
	     *   0 ALL # 全期間
	     *   1 ONE_MONTH # 1ヶ月以内
	     *   2 ONE_WEEK # 1週間以内
	     *   3 THREE_DAYS # 3日以内
	     *   4 ONE_DAY # 1日以内
	     *   5 CUSTOM # サーバの設定値を参照する値
	     */
	  }, {
	    key: '_getStages',
	    value: function _getStages() {
	      var sort = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];

	      var _this3 = this;

	      var term = arguments.length <= 1 || arguments[1] === undefined ? 0 : arguments[1];
	      var cache = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

	      var limit = 120;
	      return this.$http.get(this.apiHost + '/v1/public/craft/stage/stages', {
	        cache: cache,
	        params: { limit: limit, sort: sort, term_type: term, offset: 0 }
	      }).then(function (response) {
	        return response.data;
	      })['catch'](function (error) {
	        _this3.$log.error(angular.toJson(error.data, true));
	      });
	    }
	  }]);

	  return ApiService;
	})();

	exports.ApiService = ApiService;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var _configEnvironment = __webpack_require__(3);

	var UtilService = (function () {
	  UtilService.$inject = ["$state", "$window", "$timeout", "$log"];
	  function UtilService($state, $window, $timeout, $log) {
	    'ngInject';

	    _classCallCheck(this, UtilService);

	    this.$state = $state;
	    this.$window = $window;
	    this.$timeout = $timeout;
	    this.$log = $log;
	  }

	  _createClass(UtilService, [{
	    key: 'goTopPage',
	    value: function goTopPage() {
	      this.$state.go('featured');
	    }
	  }, {
	    key: 'goDetailPage',
	    value: function goDetailPage(id) {
	      this.$state.go('detail', { id: id });
	    }

	    /**
	     * ステージの画像パスを生成
	     * @param {string} userId
	     * @param {string} stageId
	     * @param {string} [size]
	     */
	  }, {
	    key: 'getStageImgPath',
	    value: function getStageImgPath(userId, stageId, size) {
	      var width = '';
	      var storageUrl = _configEnvironment.environment.storageUrl;
	      if (size === 's') {
	        width = '300';
	      } else if (size === 'm') {
	        width = '600';
	      }
	      if (width) {
	        width = '_' + width;
	      }
	      return storageUrl + 'users/' + userId + '/stages/' + stageId + width + '.png';
	    }

	    /**
	     * @param {string} stageId
	     */
	  }, {
	    key: 'playNow',
	    value: function playNow(stageId) {
	      stageId = stageId || '';
	      var universalLinks = _configEnvironment.environment.universalLinks;
	      var urlScheme = _configEnvironment.environment.urlScheme;
	      var webUrl = 'http://translimit.co.jp/services/braindots.html';
	      var appUrl = '';
	      var os = detectMobileOS();
	      var agent = navigator.userAgent;

	      this.$log.debug('stageId', stageId, 'os', os, 'universalLinks', universalLinks, 'urlScheme', urlScheme);

	      if (os === 'ios') {
	        if (agent.search(/OS 9/) !== -1) {
	          appUrl = universalLinks + stageId;
	        } else {
	          appUrl = urlScheme + stageId;
	        }
	        this._launchiOSApp(appUrl, webUrl);
	      } else if (os === 'android') {
	        this.$window.location = 'intent://stage/play?stage_id=' + stageId + '#Intent;scheme=jp.co.translimit.braindots;package=jp.co.translimit.braindots;end;';
	      } else if (os === 'other') {
	        this.$window.location = webUrl;
	      }
	    }
	  }, {
	    key: '_launchiOSApp',
	    value: function _launchiOSApp(appUrl, webUrl) {
	      var _this = this;

	      var checkedAt = new Date();
	      this.$timeout(function () {
	        var t = new Date() - checkedAt;
	        if (t < 2000) {
	          _this.$window.location = webUrl;
	        }
	      }, 1000);
	      this.$window.location = appUrl;
	    }
	  }]);

	  return UtilService;
	})();

	exports.UtilService = UtilService;

	function detectMobileOS() {
	  var agent = navigator.userAgent,
	      os = null;
	  if (agent.search(/iPhone/) !== -1) {
	    os = 'ios';
	  } else if (agent.search(/Android/) !== -1) {
	    os = 'android';
	  } else {
	    os = 'other';
	  }
	  return os;
	}

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var self;

	var HttpInterceptorService = (function () {
	  HttpInterceptorService.$inject = ["$q", "$rootScope"];
	  function HttpInterceptorService($q, $rootScope) {
	    'ngInject';

	    _classCallCheck(this, HttpInterceptorService);

	    this.$q = $q;
	    this.$rootScope = $rootScope;
	    this.reqCount = 0;
	    self = this;
	  }

	  _createClass(HttpInterceptorService, [{
	    key: 'request',
	    value: function request(params) {
	      self._stack();
	      return params || self.$q.when(params);
	    }
	  }, {
	    key: 'requestError',
	    value: function requestError(rejection) {
	      return self.$q.reject(rejection);
	    }
	  }, {
	    key: 'response',
	    value: function response(_response) {
	      self._unstack();
	      return _response || self.$q.when(_response);
	    }
	  }, {
	    key: 'responseError',
	    value: function responseError(rejection) {
	      self._unstack();
	      return self.$q.reject(rejection);
	    }
	  }, {
	    key: '_stack',
	    value: function _stack() {
	      self.reqCount += 1;
	      if (self.reqCount > 0) {
	        self.$rootScope.isProgress = true;
	      }
	    }
	  }, {
	    key: '_unstack',
	    value: function _unstack() {
	      self.reqCount -= 1;
	      if (self.reqCount < 1) {
	        self.$rootScope.isProgress = false;
	        self.reqCount = 0;
	      }
	    }
	  }]);

	  return HttpInterceptorService;
	})();

	exports.HttpInterceptorService = HttpInterceptorService;

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var DetailService = (function () {
	  DetailService.$inject = ["ApiService"];
	  function DetailService(ApiService) {
	    'ngInject';

	    _classCallCheck(this, DetailService);

	    this.api = ApiService;
	  }

	  /**
	   * ステージ詳細を取得
	   */

	  _createClass(DetailService, [{
	    key: 'getDetail',
	    value: function getDetail(id) {
	      return this.api.getStageDetail(id);
	    }
	  }]);

	  return DetailService;
	})();

	exports.DetailService = DetailService;

/***/ },
/* 9 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var FeaturedController = (function () {
	  FeaturedController.$inject = ["ApiService"];
	  function FeaturedController(ApiService) {
	    'ngInject';

	    // vm variables

	    _classCallCheck(this, FeaturedController);

	    this.api = ApiService;
	    this.list; // {Array}

	    // 一覧取得
	    this._getStages();
	  }

	  /**
	   * 一覧取得
	   */

	  _createClass(FeaturedController, [{
	    key: '_getStages',
	    value: function _getStages() {
	      var _this = this;

	      this.api.getFeaturedStages().then(function (data) {
	        _this.list = data.pickup_stages[0].stages;
	      });
	    }
	  }]);

	  return FeaturedController;
	})();

	exports.FeaturedController = FeaturedController;

/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var TERM_TYPES = {
	  MONTH: 1,
	  WEEK: 2,
	  THREE_DAYS: 3,
	  TODAY: 4
	};

	var TrendingController = (function () {
	  TrendingController.$inject = ["ApiService", "$state"];
	  function TrendingController(ApiService, $state) {
	    'ngInject';

	    // vm variables

	    _classCallCheck(this, TrendingController);

	    this.api = ApiService;
	    this.list; // {Array}

	    switch ($state.current.name) {
	      case 'trending/today':
	        this._getStages(TERM_TYPES.TODAY);
	        break;
	      case 'trending/three_days':
	        this._getStages(TERM_TYPES.THREE_DAYS);
	        break;
	      case 'trending/week':
	        this._getStages(TERM_TYPES.WEEK);
	        break;
	      case 'trending/month':
	        this._getStages(TERM_TYPES.MONTH);
	        break;
	    }
	  }

	  /**
	   * 一覧取得
	   * @param {number} term
	   */

	  _createClass(TrendingController, [{
	    key: '_getStages',
	    value: function _getStages(term) {
	      var _this = this;

	      this.list = null;
	      this.api.getTrendingStages(term).then(function (data) {
	        _this.list = data.stages;
	      });
	    }
	  }]);

	  return TrendingController;
	})();

	exports.TrendingController = TrendingController;

/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var NewController = (function () {
	  NewController.$inject = ["ApiService"];
	  function NewController(ApiService) {
	    'ngInject';

	    // vm variables

	    _classCallCheck(this, NewController);

	    this.api = ApiService;
	    this.list; // {Array}

	    // 一覧取得
	    this._getStages();
	  }

	  /**
	   * 一覧取得
	   */

	  _createClass(NewController, [{
	    key: '_getStages',
	    value: function _getStages() {
	      var _this = this;

	      this.api.getNewStages().then(function (data) {
	        _this.list = data.stages;
	      });
	    }
	  }]);

	  return NewController;
	})();

	exports.NewController = NewController;

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	var DetailController = (function () {
	  DetailController.$inject = ["$stateParams", "$log", "DetailService", "UtilService"];
	  function DetailController($stateParams, $log, DetailService, UtilService) {
	    'ngInject';

	    // vm variables

	    _classCallCheck(this, DetailController);

	    this.service = DetailService;
	    this.$log = $log;
	    this.util = UtilService;
	    this.stage; // {Object}
	    this.imgPath; // {string}
	    this.found = false; // {boolean}
	    this.notFound = false; // {boolean}

	    // ステージ詳細取得
	    this._getDetail($stateParams.id);
	  }

	  /**
	   * ステージ詳細取得
	   * @param {string} id ステージid
	   */

	  _createClass(DetailController, [{
	    key: '_getDetail',
	    value: function _getDetail(id) {
	      var _this = this;

	      if (!id) {
	        this.notFound = true;
	        return;
	      }

	      this.service.getDetail(id).then(function (data) {
	        _this.$log.debug(data);
	        var stage = data.stage;

	        if (stage === null) {
	          _this.notFound = true;
	        } else {
	          _this.found = true;
	          _this.stage = stage;

	          // ステージの画像パス
	          _this.imgPath = _this.util.getStageImgPath(stage.user.user_id, stage.stage_id, 'm');
	        }
	      });
	    }
	  }]);

	  return DetailController;
	})();

	exports.DetailController = DetailController;

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.HeadLogoDirective = HeadLogoDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function HeadLogoDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/headLogo/headLogo.html',
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm'
	  };
	  return directive;
	}

	var Controller = (function () {
	  Controller.$inject = ["UtilService"];
	  function Controller(UtilService) {
	    'ngInject';

	    _classCallCheck(this, Controller);

	    this.util = UtilService;
	  }

	  _createClass(Controller, [{
	    key: 'goTopPage',
	    value: function goTopPage() {
	      this.util.goTopPage();
	    }
	  }]);

	  return Controller;
	})();

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.NavbarDirective = NavbarDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function NavbarDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/navbar/navbar.html',
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm'
	  };
	  return directive;
	}

	var Controller = (function () {
	  Controller.$inject = ["$state"];
	  function Controller($state) {
	    'ngInject';

	    _classCallCheck(this, Controller);

	    this.currentState = $state.current.name;
	  }

	  _createClass(Controller, [{
	    key: 'isCurrent',
	    value: function isCurrent(state) {
	      return this.currentState.indexOf(state) > -1;
	    }
	  }]);

	  return Controller;
	})();

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.PopoverMenuDirective = PopoverMenuDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function PopoverMenuDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/popoverMenu/popoverMenu.html',
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm'
	  };
	  return directive;
	}

	var Controller = (function () {
	  Controller.$inject = ["$state"];
	  function Controller($state) {
	    'ngInject';

	    _classCallCheck(this, Controller);

	    this.currentState = $state.current.name;
	    this.visible = false;
	    this.menus = [{
	      name: 'Today',
	      state: 'trending/today'
	    }, {
	      name: 'The past 3days',
	      state: 'trending/three_days'
	    }, {
	      name: 'This week',
	      state: 'trending/week'
	    }, {
	      name: 'This month',
	      state: 'trending/month'
	    }];
	  }

	  _createClass(Controller, [{
	    key: 'toggleMenu',
	    value: function toggleMenu() {
	      this.visible = !this.visible;
	    }
	  }, {
	    key: 'getCurrentStateName',
	    value: function getCurrentStateName() {
	      var len = this.menus.length;
	      var name = '';
	      for (var i = 0; i < len; i += 1) {
	        if (this.menus[i].state === this.currentState) {
	          name = this.menus[i].name;
	          break;
	        }
	      }
	      return name;
	    }
	  }, {
	    key: 'isCurrentState',
	    value: function isCurrentState(state) {
	      return this.currentState === state;
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.visible = false;
	    }
	  }]);

	  return Controller;
	})();

/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports.ProgressIndicatorDirective = ProgressIndicatorDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function ProgressIndicatorDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/progressIndicator/progressIndicator.html',
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm'
	  };
	  return directive;
	}

	var Controller = function Controller() {
	  'ngInject';

	  _classCallCheck(this, Controller);
	};

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.StageListDirective = StageListDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function StageListDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/stageList/stageList.html',
	    bindToController: {
	      list: '=',
	      badgeType: '@'
	    },
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm'
	  };
	  return directive;
	}

	var Controller = (function () {
	  Controller.$inject = ["$scope", "$log", "UtilService"];
	  function Controller($scope, $log, UtilService) {
	    'ngInject';

	    // vm variables

	    var _this = this;

	    _classCallCheck(this, Controller);

	    this.firstStage; // {Object}
	    this.util = UtilService;

	    // events
	    $scope.$watch('vm.list', function (value) {
	      if (value && value[0]) {
	        _this.firstStage = value.shift();
	      } else {
	        _this.firstStage = null;
	      }
	    });
	  }

	  /**
	   * ステージの画像パスを取得
	   * @param {Object} stage
	   * @param {string} [size]
	   * @return {string} img path
	   */

	  _createClass(Controller, [{
	    key: 'getImgPath',
	    value: function getImgPath(stage, size) {
	      if (stage && stage.user) {
	        return this.util.getStageImgPath(stage.user.user_id, stage.stage_id, size);
	      }
	    }

	    /**
	     * 詳細ページへ移動
	     */
	  }, {
	    key: 'goDetailPage',
	    value: function goDetailPage(id) {
	      this.util.goDetailPage(id);
	    }
	  }]);

	  return Controller;
	})();

/***/ },
/* 18 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.StageBadgeDirective = StageBadgeDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function StageBadgeDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/components/stageBadge/stageBadge.html',
	    bindToController: {
	      type: '=',
	      stage: '='
	    },
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm'
	  };
	  return directive;
	}

	var Controller = (function () {
	  function Controller() {
	    'ngInject';

	    _classCallCheck(this, Controller);
	  }

	  /**
	   * 作成されてからどのくらい時間が経ったか
	   * @return {string} e.g. 30 min
	   */

	  _createClass(Controller, [{
	    key: 'getTime',
	    value: function getTime() {
	      if (this.stage) {
	        var s = this.stage.publish_elapsed_seconds;
	        var m = Math.floor(s / 60);
	        var h = Math.floor(m / 60);
	        var d = Math.floor(h / 24);
	        if (d > 0) {
	          return d + ' day';
	        }
	        if (h > 0) {
	          return h + ' hour';
	        }
	        if (m > 0) {
	          return m + ' min';
	        }
	        return s + ' sec';
	      }
	    }
	  }]);

	  return Controller;
	})();

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.DetailDescriptionDirective = DetailDescriptionDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function DetailDescriptionDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/detail/directives/detailDescription.html',
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: {
	      stage: '='
	    }
	  };
	  return directive;
	}

	var Controller = (function () {
	  Controller.$inject = ["$scope"];
	  function Controller($scope) {
	    'ngInject';

	    // vm variables

	    var _this = this;

	    _classCallCheck(this, Controller);

	    this.successRate = '';

	    $scope.$watch('vm.stage', function (value) {
	      if (value) {
	        _this.successRate = _this._getSuccessRate(value);
	      }
	    });
	  }

	  /**
	   * ステージ成功率のテキストを生成
	   * @param {Object} stage
	   * @param {number} stage.success_count
	   * @param {number} stage.challenge_count
	   * @return {string} e.g. 67.96% (70/103)
	   */

	  _createClass(Controller, [{
	    key: '_getSuccessRate',
	    value: function _getSuccessRate(stage) {
	      var success = stage.success_count;
	      var challenge = stage.challenge_count;
	      var percent = undefined;
	      if (challenge === 0) {
	        percent = '-%';
	      } else {
	        percent = Math.floor(success / challenge * 10000) / 100 + '%';
	      }
	      return percent + ' (' + success + '/' + challenge + ')';
	    }
	  }]);

	  return Controller;
	})();

/***/ },
/* 20 */
/***/ function(module, exports) {

	// import { environment } from '../../../config/environment';

	'use strict';

	Object.defineProperty(exports, '__esModule', {
	  value: true
	});

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	exports.DetailButtonsDirective = DetailButtonsDirective;

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function DetailButtonsDirective() {
	  'ngInject';
	  var directive = {
	    restrict: 'E',
	    templateUrl: 'app/detail/directives/detailButtons.html',
	    scope: {},
	    controller: Controller,
	    controllerAs: 'vm',
	    bindToController: {
	      stageId: '='
	    }
	  };
	  return directive;
	}

	var Controller = (function () {
	  Controller.$inject = ["UtilService"];
	  function Controller(UtilService) {
	    'ngInject';

	    _classCallCheck(this, Controller);

	    this.util = UtilService;
	  }

	  _createClass(Controller, [{
	    key: 'goTopPage',
	    value: function goTopPage() {
	      this.util.goTopPage();
	    }
	  }, {
	    key: 'playNow',
	    value: function playNow() {
	      this.util.playNow(this.stageId);
	    }
	  }]);

	  return Controller;
	})();

/***/ }
/******/ ]);
angular.module("braindotsWeb").run(["$templateCache", function($templateCache) {$templateCache.put("app/detail/detail.html","<div class=\"detail text-center\"><div ng-if=\"vm.found\"><img ng-src=\"{{vm.imgPath}}\" class=\"u-shadow\" width=\"290\" height=\"164\"><detail-description stage=\"vm.stage\"></detail-description><detail-buttons stage-id=\"vm.stage.stage_id\"></detail-buttons></div><div ng-if=\"vm.notFound\"><div class=\"u-m-b-md\">This stage is already deleted.</div><img class=\"u-m-b-lg\" src=\"assets/images/not-found.png\" width=\"290\" height=\"144\"><detail-buttons stage-id=\"vm.stage.stage_id\"></detail-buttons></div></div>");
$templateCache.put("app/featured/featured.html","<div class=\"featured\"><stage-list list=\"vm.list\" badge-type=\"like\"></stage-list></div>");
$templateCache.put("app/new/new.html","<div class=\"new\"><stage-list list=\"vm.list\" badge-type=\"time\"></stage-list></div>");
$templateCache.put("app/trending/trending.html","<div class=\"trending\"><popover-menu func1=\"vm.getToday()\" func2=\"vm.get3Days()\" func3=\"vm.getWeek()\" func4=\"vm.getMonth()\"></popover-menu><stage-list list=\"vm.list\" badge-type=\"like\"></stage-list></div>");
$templateCache.put("app/components/headLogo/headLogo.html","<header><img src=\"assets/images/logo.svg\" width=\"158\" height=\"40\" ng-click=\"vm.goTopPage()\"></header>");
$templateCache.put("app/components/navbar/navbar.html","<nav><a ui-sref=\"featured\" ng-disabled=\"vm.isCurrent(\'featured\')\"><i class=\"icon-featured\"></i><span>Featured</span></a><a ui-sref=\"trending/today\" ng-disabled=\"vm.isCurrent(\'trending\')\"><i class=\"icon-trending\"></i><span>Trending</span></a><a ui-sref=\"new\" ng-disabled=\"vm.isCurrent(\'new\')\"><i class=\"icon-new\"></i><span>New</span></a></nav>");
$templateCache.put("app/components/popoverMenu/popoverMenu.html","<div class=\"btn btn-link\" ng-click=\"vm.toggleMenu()\">{{ vm.getCurrentStateName() }}</div><div class=\"popover popover-bottom\" ng-if=\"vm.visible\"><div class=\"popover-arrow\"></div><div class=\"popover-content\"><ul><li ng-repeat=\"menu in vm.menus\"><a ui-sref=\"{{ menu.state }}\" ng-class=\"{ current: vm.isCurrentState(menu.state) }\">{{ menu.name }}</a></li></ul></div></div><div ng-click=\"vm.close()\" class=\"popover-menu__backdrop\" ng-if=\"vm.visible\"></div>");
$templateCache.put("app/components/progressIndicator/progressIndicator.html","<div class=\"progress-indicator__ball\"></div><div class=\"progress-indicator__text\">Loading...</div>");
$templateCache.put("app/components/stageBadge/stageBadge.html","<div ng-switch=\"vm.type\"><div ng-switch-when=\"time\" class=\"stage-badge__part stage-badge__part--time\"><i class=\"icon-clock\"></i><span>{{ vm.getTime() }}</span></div><div ng-switch-when=\"like\" class=\"stage-badge__part stage-badge__part--like\"><i class=\"icon-like\"></i><span>{{ vm.stage.like_count | number }}</span></div></div>");
$templateCache.put("app/components/stageList/stageList.html","<div class=\"stage-list__large\" ng-if=\"vm.firstStage\"><stage-badge stage=\"vm.firstStage\" type=\"vm.badgeType\" class=\"stage-badge--large\"></stage-badge><img ng-src=\"{{vm.getImgPath(vm.firstStage, \'m\')}}\" width=\"288\" height=\"162\" ng-click=\"vm.goDetailPage(vm.firstStage.stage_id)\"></div><div class=\"stage-list__smalls\"><div ng-repeat=\"stage in vm.list\" class=\"stage-list__small\"><stage-badge stage=\"stage\" type=\"vm.badgeType\"></stage-badge><img ng-src=\"{{vm.getImgPath(stage, \'s\')}}\" width=\"136\" height=\"77\" ng-click=\"vm.goDetailPage(stage.stage_id)\"></div></div>");
$templateCache.put("app/detail/directives/detailButtons.html","<div><button type=\"button\" class=\"btn btn-primary btn-pill detail-buttons__play\" ng-click=\"vm.playNow()\">Play Now</button></div><div><button type=\"button\" class=\"btn btn-link detail-buttons__search\" ng-click=\"vm.goTopPage()\"><i class=\"icon-search\"></i>Find another Stages</button></div>");
$templateCache.put("app/detail/directives/detailDescription.html","<div class=\"detail-description__rating\"><i class=\"icon-check\"></i><span>{{vm.successRate}}</span><i class=\"icon-like\"></i><span>{{vm.stage.like_count}}</span></div><div class=\"detail-description__name\"><span class=\"sprite\" ng-class=\"vm.stage.user.country_code\"></span><span>{{vm.stage.user.name}}</span></div>");}]);